import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiQueryHook } from '../../../common/queryClient/createApiQueryHook';
import {
  type HasPendingDraftsType,
  HasPendingDraftsSchema,
} from '../../../edit-session/schema/EditSessionSchema';
import { SampleEditSessionUrl } from '../SampleEditSessionUrl';

const fetchSampleEditSessionHasDrafts = async (params: { sessionId: string }) =>
  apiClient
    .get<HasPendingDraftsType>(
      expand(SampleEditSessionUrl.hasPendingDrafts, params),
    )
    .then((response) => response.data)
    .then(HasPendingDraftsSchema.parse);

export const useSampleEditSessionHasDraftsQuery = createApiQueryHook(
  ['sample-edit-session-has-drafts'],
  fetchSampleEditSessionHasDrafts,
);
